import axios from '@axios'

export default {
  namespaced: true,
  state: { items: [] },
  getters: { getItems: state => state.items },
  mutations: {
    setData(state, value) { state.items = value },
  },
  actions: {
    async getAll({ commit }, params = {}) {
      const { data } = await axios.get('v1/hanwha/alarm-rules', { params })
      commit('setData', data?.data || [])
      return data
    },
    async add(_, params) {
      const { data } = await axios.post('v1/hanwha/alarm-rules', params)
      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/hanwha/alarm-rules/${id}`, params)
      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/hanwha/alarm-rules/${id}`)
      return data
    },
  },
}
